import { IParamValue } from '@move-frontend/portal-toolkit';

export function removeEmptyFields(object: object | undefined): { [key: string]: IParamValue } | undefined {
  return object ? Object.fromEntries(Object.entries(object).filter(([, value]) => value !== undefined)) : object;
}
